import _                                from 'underscore';
import React, { FC, PropsWithChildren } from 'react';
import { PolyRenderer }                 from './PolyRenderer';

interface EqualValuesProps<T = never> extends PropsWithChildren<any> {
	value: any,
	test?: any,
	fallback?: any,
}

const EqualValuesDefaultProps = {
	value:    null,
	test:     undefined,
	fallback: null,
} satisfies Partial<EqualValuesProps>

function EqualValues<T>( { children, ...p }: EqualValuesProps<T> ){
	
	const props = { ...EqualValuesDefaultProps, ...p };
	
	let valid;
	
	if( _.isObject( props.value ) && _.isObject( props.test ) ){
		
		valid = ( _.isEqual( props.value, props.test ) );
		
	} else if( _.isArray( props.test ) ){
		
		valid = _.some( props.test, ( test ) => ( props.value === test ) );
		
	} else if( _.isUndefined( props.test ) ){
		
		valid = ( true && props.value );
		
	} else {
		
		valid = ( props.value === props.test );
	}
	
	return valid
	       ? <>{ children }</>
	       : <PolyRenderer value={ props.fallback }/>;
}

const MemoedEqualValues = React.memo( EqualValues );

const UseIf: FC<{
	x: EqualValuesProps[ 'value' ],
	eq?: EqualValuesProps[ 'test' ],
	else?: EqualValuesProps[ 'fallback' ],
}> = ( { children, ...props } ) => ( <EqualValues value={ props.x } test={ props.eq ?? undefined } fallback={ props.else }>{ children }</EqualValues> );

export {
	MemoedEqualValues as EqualValues,
	EqualValuesDefaultProps,
	type EqualValuesProps,
	UseIf
};
